//GeneratorFlag:[NoChange]
import { defineAsyncComponent, markRaw } from "vue";

const activityCompose = {

	info: {
		name: 'kaveh.app.toolbar.aut.activityCompose',
		iconName: 'bi-journal-plus',
		hasCounter: false,
	},

	getData: async () =>
	{
		return null;
	},

	getComponent: () => markRaw(defineAsyncComponent(() => import('./views/activity-compose.vue'))),
}


export default activityCompose
